import { render, staticRenderFns } from "./MobileFeedback.vue?vue&type=template&id=677c82ad&scoped=true&"
import script from "./MobileFeedback.vue?vue&type=script&lang=js&"
export * from "./MobileFeedback.vue?vue&type=script&lang=js&"
import style0 from "./MobileFeedback.vue?vue&type=style&index=0&id=677c82ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677c82ad",
  null
  
)

export default component.exports